import { render, staticRenderFns } from "./DepositAndWithdrawal.vue?vue&type=template&id=74d31bf7&scoped=true&"
import script from "./DepositAndWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DepositAndWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./DepositAndWithdrawal.vue?vue&type=style&index=0&id=74d31bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d31bf7",
  null
  
)

export default component.exports